module.exports = __webpack_public_path__ + "img/catherine.2db5254a.jpg";